import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'
import Loadable from '../../base/components/Template/Loadable/Loadable'

const AppPuntoVentaGestion = Loadable(lazy(() => import('./view/PuntoVenta')))
const AppNuevo = Loadable(lazy(() => import('./view/registro/PuntoVentaRegistro')))
const AppActualizar = Loadable(lazy(() => import('./view/actualizar/PuntoVentaActualizar')))
export const puntoVentaRoutesMap = {
  gestion: {
    path: '/puntoVenta/gestion',
    name: 'Puntos Venta',
    actionSecure: 'administrar',
  },
  nuevo: {
    path: '/puntoVenta/nuevo',
    name: 'Nuevo Punto de Venta',
  },
  modificar: {
    path: `/puntoVenta/modificar`,
    name: 'Consultar Punto de Venta',
  },
}
const puntoVentaRoutes = [
  {
    path: puntoVentaRoutesMap.gestion.path,
    element: <AppPuntoVentaGestion />,
    auth: authRoles.admin,
  },
  {
    path: puntoVentaRoutesMap.nuevo.path,
    element: <AppNuevo />,
    auth: authRoles.admin,
  },
  {
    path: `${puntoVentaRoutesMap.modificar.path}/:id`,
    element: <AppActualizar />,
    auth: authRoles.admin,
  },
]

export default puntoVentaRoutes
